<form [formGroup]="form" class="container-fluid" [ngClass]="{'container-fluid-no-padding': marginless}">
  <!-- Card Number -->
  <div class="fv-row mb-2">
    <label class="form-label required">{{ 'CARD_FORM.CARD_NUMBER' | translate }}</label>
    <mat-form-field class="mat-form-field-fluid">

      <input
        matInput
        formControlName="cardNumber"
        placeholder="1234 5678 9012 3456"
        inputmode="numeric"
        (blur)="handleOnTouched()"
        data-openreplay-obscured
      />
      <div mat-icon-button matSuffix class="me-3">
        <app-card-icon [type]="cardType"></app-card-icon>
      </div>

      <mat-error *ngIf="form.get('cardNumber')?.hasError('invalidCardNumber')">
        {{ 'CARD_FORM.INVALID_CARD_NUMBER' | translate }}
      </mat-error>
      <mat-error *ngIf="form.get('cardNumber')?.hasError('required')">
        {{ 'CARD_FORM.CARD_NUMBER_REQUIRED' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="row card-detail-row" [class.flex-nowrap]="collectZip">
    <div [ngClass]="expirationColumnClass">
      <label class="form-label required">{{ 'CARD_FORM.EXPIRATION_DATE' | translate }}</label>
      <!-- Expiration Date -->
      <mat-form-field  class="mat-form-field-fluid">
 
        <input
          matInput
          formControlName="expirationDate"
          placeholder="MM/YY"
          inputmode="numeric"
          (blur)="handleOnTouched()"
          data-openreplay-obscured
        />
        <mat-error
          *ngIf="form.get('expirationDate')?.hasError('invalidExpirationDate')"
        >
          {{ 'CARD_FORM.INVALID_EXPIRATION_DATE' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('expirationDate')?.hasError('required')">
          {{ 'CARD_FORM.EXPIRATION_DATE_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div [ngClass]="collectZip ? 'col-4' : 'col-sm-4'" *ngIf="showCvc">
      <!-- CVC -->
      <label class="form-label required">{{ 'CARD_FORM.SECURITY_CODE' | translate }}</label>
      <mat-form-field class="mat-form-field-fluid">

        <input
          matInput
          formControlName="cvc"
          placeholder="CVC"
          inputmode="numeric"
          data-openreplay-obscured
          (blur)="handleOnTouched()"
        />
        <mat-error *ngIf="form.get('cvc')?.hasError('required')">
          {{ 'CARD_FORM.CVC_REQUIRED' | translate }}
        </mat-error>
        <mat-error
          *ngIf="
            form.get('cvc')?.hasError('minlength') ||
            form.get('cvc')?.hasError('maxlength')
          "
        >
          {{ 'CARD_FORM.CVC_LENGTH_INVALID' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-4" *ngIf="collectZip">
      <label class="form-label required">{{ 'CARD_FORM.ZIP' | translate }}</label>
      <mat-form-field class="mat-form-field-fluid">
        <input
          matInput
          class="postal-code-input"
          formControlName="postalCode"
          [placeholder]="'CARD_FORM.ZIP' | translate"
          inputmode="text"
          autocomplete="postal-code"
          (change)="syncPostalCode($event)"
          (animationstart)="syncPostalCode($event)"
          (blur)="handleOnTouched()"
          data-openreplay-obscured
        />
        <mat-error *ngIf="form.get('postalCode')?.hasError('required')">
          {{ 'CARD_FORM.ZIP_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="form-check form-check-custom form-check-solid save-for-later mt-1">
    <input
      class="form-check-input"
      type="checkbox"
      checked
      disabled
      tabindex="-1"
    />
    <label class="form-check-label">{{
      'CARD_FORM.SAVE_FOR_FUTURE_PAYMENTS' | translate
    }}</label>
  </div>
</form>
